import * as React from "react"
import styled from "styled-components"

const DropdownWrapper = styled.div`
  border-radius: 10px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.2);
  background: white;
  display: flex;
  z-index: 100;
  flex-direction: column;
  width: auto;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 26px;
  padding-right: 26px;
`

const DropdownMenuItem = styled.div`
  display: inline-block;
  font-size: 18px;
  line-height: 20px;
  font-weight: normal;
  padding: 11px;
`

const Dropdown = props => (
  <DropdownWrapper>
    {props.children.map((el, i) => (
      <DropdownMenuItem key={i}>{el}</DropdownMenuItem>
    ))}
  </DropdownWrapper>
)

export default Dropdown
